/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Wl_NoteInputs */

const en_st_wl_note = /** @type {(inputs: St_Wl_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do you write proposals and progress reports today?`)
};

const id_st_wl_note = /** @type {(inputs: St_Wl_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagaimana kamu membuat proposal dan laporan progres sekarang?`)
};

/**
* | output |
* | --- |
* | "How do you write proposals and progress reports today?" |
*
* @param {St_Wl_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_wl_note = /** @type {((inputs?: St_Wl_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Wl_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_wl_note(inputs)
	return en_st_wl_note(inputs)
});